module.exports = __webpack_public_path__ + "static/img/bottom1.fb563f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bottom1.jpg
// module id = JyK4
// module chunks = 24